var map = {
	"./common.json": 79802,
	"./conversation.json": 9640,
	"./layout.json": 86801,
	"./resultPage.json": 9689,
	"locales/en/common.json": 79802,
	"locales/en/conversation.json": 9640,
	"locales/en/layout.json": 86801,
	"locales/en/resultPage.json": 9689
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24254;